import { render } from "./FindInsightsButton.vue?vue&type=template&id=335be04e"
import script from "./FindInsightsButton.vue?vue&type=script&lang=js"
export * from "./FindInsightsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__